import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { config } from '@branding/config';
import BugsnagPerformance from '@bugsnag/browser-performance';

const bugsnag = Bugsnag.start({
	apiKey: config.bugsnagKey,
	plugins: [new BugsnagPluginReact()],
	releaseStage: config.environment,
	enabledReleaseStages: ['stg', 'prod'],
	appVersion: config.appVersion,
	// onError: (e) => {},
});
BugsnagPerformance.start({ apiKey: config.bugsnagKey, appVersion: config.appVersion });

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

export { bugsnag, ErrorBoundary };
